import * as React from "react";
import Container from "react-bootstrap/Container";
import { HouseHeart } from "react-bootstrap-icons";
import { LinkContainer } from "react-router-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import classNames from "classnames";

import "../styles/navbar.css";

const registryUrl = "https://www.zola.com/registry/snigdha-and-sushain";

const PageNavbar = ({ className }: { className?: string }) => {
  return (
    <Container>
      <Navbar
        className={classNames(
          "page-navbar fs-5 text-uppercase d-flex justify-content-center",
          className
        )}
        expand="md"
      >
        <Navbar.Toggle aria-controls="navbar" className="d-print-none d-none" />
        <Navbar.Brand className="d-md-none tagline mobile-tagline" href="#home">
          {"Snigdha & Sushain"}
        </Navbar.Brand>
        <Navbar.Collapse className="justify-content-center" id="navbar">
          <Nav className="justify-content-around flex-grow-1 d-none">
            <LinkContainer className="d-md-none" to="/">
              <Nav.Link>
                <span className="d-md-none">Home</span>
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/about-us">
              <Nav.Link>About Us</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/updates">
              <Nav.Link>Updates</Nav.Link>
            </LinkContainer>
            <LinkContainer
              isActive={(_, { pathname }) => pathname.startsWith("/rsvp")}
              to="/rsvp"
            >
              <Nav.Link>RSVP</Nav.Link>
            </LinkContainer>
            <LinkContainer className="d-none d-md-block" to="/">
              <Nav.Link aria-label="Home">
                <HouseHeart className="align-baseline" size="1.5rem" />
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/schedule">
              <Nav.Link>Schedule</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/q-and-a">
              <Nav.Link>Q & A</Nav.Link>
            </LinkContainer>
            <Nav.Link href={registryUrl} rel="noreferrer" target="_blank">
              Registry
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
};

export default PageNavbar;
export { registryUrl };
